import { APP_COLOR } from '@/theme/color';
import { motion, useReducedMotion } from 'motion/react';

const WAVE_BAR_COUNT = 5;

/** Simple play-area placeholder: soft bars with staggered opacity (no maze bitmap). */
export function MazePlayAreaSkeleton() {
  const reduceMotion = useReducedMotion();

  return (
    <div
      className="aspect-square w-[min(100%,14rem)] max-h-[min(100%,14rem)] rounded-xl border p-5"
      style={{
        backgroundColor: "transparent",
        borderColor: "transparent",
      }}
      aria-hidden
    >
      <div className="flex h-full w-full flex-col items-center justify-center gap-3">
        {Array.from({ length: WAVE_BAR_COUNT }, (_, index) => (
          <motion.div
            key={index}
            className="h-2 max-w-full rounded-full"
            style={{
              backgroundColor: APP_COLOR.accentSoft30,
              width: `${78 - index * 10}%`,
            }}
            animate={reduceMotion ? { opacity: 0.42 } : { opacity: [0.22, 0.72, 0.22] }}
            transition={
              reduceMotion
                ? undefined
                : {
                    duration: 1.35,
                    repeat: Infinity,
                    delay: index * 0.1,
                    ease: 'easeInOut',
                  }
            }
          />
        ))}
      </div>
    </div>
  );
}
